const menuButton = document.querySelector('.menu-toggle');
const menu = document.querySelector('#main-nav');
menuButton.addEventListener('click', () => {
  const open = menuButton.getAttribute('aria-expanded') !== 'true';
  menuButton.setAttribute('aria-expanded', String(open));
  menu.classList.toggle('is-open', open);
  menuButton.querySelector('span').textContent = open ? '−' : '+';
});
menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
  menu.classList.remove('is-open'); menuButton.setAttribute('aria-expanded', 'false');
  menuButton.querySelector('span').textContent = '+';
}));
const projects = window.DIANA_CONTENT.projects;
const dialog = document.querySelector('#project-dialog');
const photo = document.querySelector('#project-photo');
const viewButtons = Array.from(document.querySelectorAll('[data-view]'));
let currentProject;
function setView(view) {
  const isMold = view === 'mold' && currentProject.mold;
  photo.src = isMold ? currentProject.mold : currentProject.concept;
  photo.alt = isMold ? currentProject.title + dianaT(': vessel, separate lid and four conceptual mold shell parts') : currentProject.alt;
  viewButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === (isMold ? 'mold' : 'concept'))));
}
document.querySelectorAll('[data-project]').forEach(button => button.addEventListener('click', () => {
  currentProject = projects[button.dataset.project];
  document.querySelector('#project-title').textContent = currentProject.title;
  document.querySelector('#project-category').textContent = currentProject.category;
  document.querySelector('#project-description').textContent = currentProject.description;
  document.querySelector('#project-approach').textContent = currentProject.approach;
  document.querySelector('[data-view="mold"]').hidden = !currentProject.mold;
  setView('concept');
  dialog.showModal();
  document.body.classList.add('no-scroll');
}));
viewButtons.forEach(button => button.addEventListener('click', () => setView(button.dataset.view)));
document.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
dialog.addEventListener('click', event => {if (event.target === dialog) {const box=dialog.getBoundingClientRect(); if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom) dialog.close();}});
dialog.addEventListener('close', () => document.body.classList.remove('no-scroll'));
document.querySelector('.project-enquire').addEventListener('click', () => dialog.close());
